import React, { useCallback, FocusEvent, useState, useEffect, useRef } from "react";
import {
  retornoAutoComplete,
  AutocompleteSaurus,
} from "../autocomplete-saurus/autocomplete-saurus";
import { useGetPessoa, useGetPessoaById } from "data/api/gestao/pessoa";
import { PessoasModel } from "model/api/gestao/pessoa/pessoas-model";
import { EnumTipoPessoas } from "model/enums/enum-tipo-pessoas";
import { isEmpty } from "lodash";

export interface AutocompleteRevendasProps {
  label?: string;
  loadingExterno?: boolean;
  name?: string;
  value?: string;
  defaultValue?: string;
  defaultName?: string;
  error?: boolean;
  helperText?: string | undefined;
  placeholder?: string;
  allowSubmit?: boolean;
  disabled?: boolean;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => any;
  onChange?: (value: retornoAutoComplete) => any;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
  fetchOnLoad?: boolean;
  query?: string;
  focus?: boolean;
  onClick?: (e?: any) => any;
}

export const AutocompleteAgenteExterno = ({
  onChange,
  loadingExterno,
  fullWidth,
  ...props
}: AutocompleteRevendasProps) => {
  const [agenteExternoState, setAgenteExternoState] = useState<Array<PessoasModel>>(
    new Array<PessoasModel>()
  );
  const { getPessoa, carregando: carregandoPessoas } = useGetPessoa()
  const { getPessoaById, carregando: carregandoPessoa } = useGetPessoaById()

  const [nomeValor, setNomeValor] = useState<string>('')

  const allowFetch = useRef<boolean>(true)

  const getAgenteExternoById = useCallback(async (id: string) => {
    try {
      const res = await getPessoaById(id)

      if (res.erro) throw res.erro

      if (!res.resultado) return
      allowFetch.current = false
      setAgenteExternoState([res.resultado.data])
    } catch (e: any) {

    }
  }, [getPessoaById])

  const getAgenteExternoWrapper = useCallback(async (termo: string) => {
    try {

      const ret = await getPessoa(1, `pageSize=0&tipoPessoa=${EnumTipoPessoas.AgenteExterno}&${termo.length > 0 ? `query=${termo}` : ''}`);
      if (ret.erro) throw ret.erro;
      let revendas: Array<PessoasModel> = new Array<PessoasModel>();
      if (!ret.resultado) return
      if (ret.resultado?.data?.list?.length > 0) {
        revendas = ret.resultado?.data?.list as Array<PessoasModel>;
      }
      setAgenteExternoState(revendas)
    } catch (e: any) { }
  }, [getPessoa]);

  const onChangeWrapper = useCallback(
    (value: retornoAutoComplete) => {
      if (onChange) onChange(value);
    },
    [onChange]
  );

  const carregando = carregandoPessoas || carregandoPessoa || loadingExterno

  const onPesquisa = useCallback(
    async (termo: string) => {
      await getAgenteExternoWrapper(termo);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [getAgenteExternoWrapper]
  );

  useEffect(() => {
    if (!isEmpty(props.defaultValue) && !isEmpty(props.defaultName)) {
      setAgenteExternoState([new PessoasModel(props.defaultValue, EnumTipoPessoas.Revendedor, props.defaultName)])
      setNomeValor(props.defaultName!)
      return
    }
    if (!isEmpty(props.defaultValue) && props.fetchOnLoad) {
      getAgenteExternoById(props.defaultValue!)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.defaultValue])


  useEffect(() => {
    if (props.value) {
      const valor = agenteExternoState.find(item =>
        item.id === props.value
      )

      setNomeValor((valor?.nomeComercial ?? props.defaultName) || '')
      return
    }
    setNomeValor('')
  }, [props, props.fetchOnLoad, props.value, agenteExternoState])

  useEffect(() => {
    onPesquisa('')
  }, [onPesquisa])

  return (
    <AutocompleteSaurus
      disabled={props.disabled}
      name={props.name}
      loading={carregando}
      onChange={onChangeWrapper}
      onPesquisa={onPesquisa}
      onClick={props.onClick}
      opcoes={agenteExternoState}
      optionLabelKey="nomeComercial"
      optionValueKey="nomeComercial"
      onBlur={props.onBlur}
      noOptionsText="Agente Externo não localizado."
      value={nomeValor}
      allowSubmit={props.allowSubmit}
      label={props.label}
      helperText={props.helperText}
      error={props.error}
      placeholder={props.placeholder}
      fullWidth={fullWidth}
      size={props.size}
      focus={props.focus}
    />
  );
};
